export default function getWKT (geojson) {
  if (geojson !== null) {
    const coords = geojson.geometry.coordinates[0].map((x) => x.join(' '))
      .join(',')
    return 'GEOMETRYCOLLECTION(POLYGON(('.concat(coords, ')))')
  }
  return ''
}
